import React, {useState} from "react";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import styles from './PasswordInput.module.sass';

const PasswordInput = ({ onValueChange, placeholder, error, value }) => {

    const [showContent, setShowContent] = useState(false);

    return (
        <div className={styles.input_container}>
            <input
                type={showContent ? 'text' : 'password'}
                placeholder={placeholder}
                className={error && 'error'}
                onChange={(event) => { onValueChange?.( event.target.value ) }}
                value={value}
            />
            <button
                onClick={() => {
                    setShowContent(!showContent);
                }} className="input_icon">
                {showContent ? <Visibility /> : <VisibilityOff />}
            </button>
        </div>
    );

};

export default PasswordInput;